import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { CompanyService } from 'src/app/company.service';
import { CompanyModel } from 'src/app/_models/Company/CompanyModel';
import { GetHostsModelResponse } from 'src/app/_models/Host/HostModel';
import { Operations } from 'src/app/_models/Operations/Operations';
import { ApiService } from 'src/app/_services/api.service';
import { HostService } from 'src/app/_services/host.service';
import { HostDialogComponent } from '../hosts/host-dialog/host-dialog.component';

@Component({
  selector: 'app-staff-members',
  templateUrl: './staff-members.component.html',
  styleUrls: ['./staff-members.component.scss']
})
export class StaffMembersComponent implements OnInit {

  company: CompanyModel;
  companyId: string = '';

  hostSubscription: Subscription;
  public hostsList?: GetHostsModelResponse[] = [];
  loading: boolean = false;
  @ViewChild('search') searchElementRef: ElementRef;

  constructor(
    private hostService: HostService,
    private dialog: MatDialog,
    private apiService: ApiService,
    private companyService: CompanyService,
  ) { }

  ngOnInit(): void {
    this.getCompany();
    this.getCompanyId();
    this.apiService.getHostsByCompany(this.companyId).subscribe((response) => {
      this.hostsList = response;
    });
    this.fetchHosts();
  }

  openAddHost() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.panelClass = 'custom-modal';

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      operation: Operations.Add,
    };

    const dialogRef = this.dialog.open(HostDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(closed => {
      if (!closed) {
        this.apiService.getHostsByCompany(this.companyId).subscribe();
      }
    });
  }

  fetchHosts() {
    this.hostSubscription = this.hostService.hostChanged
      .subscribe(
        (hosts: GetHostsModelResponse[]) => {
          this.hostsList = hosts;
        }
      );
    this.hostsList = this.hostService.getHosts();
  }

  getCompanyId() {
    this.companyId = this.companyService.getCompanyId();
  }

  getCompany(){
    this.company = this.companyService.getCompany();
  }

}
